import { usePagination } from '@hooks';

export type PendingDispersionStatus = 'PENDING' | 'APPROVED' | 'REJECTED';

export interface PendingDispersion {
  id: string;
  dispersionId: string;
  createdBy: string;
  attemptedAmount: number;
  usersCount: number;
  customerId: number;
  areaId: string | null;
  filePath: string;
  fileName: string;
  scheduledDate: string | null;
  status: PendingDispersionStatus;
  resolvedBy: string | null;
  resolvedAt: string | null;
  createdAt: string;
  updatedAt: string;
  customerName?: string;
  companyName?: string;
  areaName?: string | null;
}

export interface PendingDispersionsResponse {
  page: PendingDispersion[];
  limit: number;
  offset: number;
  totalCount: number;
  totalPages: number;
  currentPage: number;
  previousPage: number | null;
  nextPage: number | null;
}

interface GetPendingDispersionsParams {
  params: object;
  setURLparams: () => void;
}

/**
 * Fetches pending dispersions paginated
 */
const useGetPendingDispersions = ({ params, setURLparams }: GetPendingDispersionsParams) => {
  const { data: paginatedData, ...props } = usePagination('/v3/dispersion/pending', {
    params,
    setURLparams,
    paramKeys: ['page', 'limit', 'status'],
  });

  const data = paginatedData as PendingDispersionsResponse | undefined;

  return { data, ...props };
};

export default useGetPendingDispersions;
